<div style="height: 125px;">
  <app-header></app-header>
</div>
<div class="base-sections">

  <section class="bg-section full-view" id="home">
    <div class="home-descritivo">
      <img src="../../../assets/img/institucional/home/PicPontos_home.png" alt="">
      <p>Mais opções para sua <br>
        campanha de incentivo <br>
        e prêmios para sua equipe</p>

      <a (click)="navigateTo('contato')"><button class="btn btn-default-v2 button-xl">Quero inovar <br> minha
          campanha</button></a>

    </div>

    <div class="imagens">
      <div class="img-computador">
        <img src="../../../assets/img/institucional/home/computador.png" alt="">
      </div>

      <div class="img-panela_celular">
        <div>
          <img src="../../../assets/img/institucional/home/viagem.png" alt="">
        </div>
        <div>
          <img src="../../../assets/img/institucional/home/celular.png" alt="">
        </div>
      </div>
    </div>

    <div class="home-descritivo button-xs">
      <a (click)="navigateTo('contato')"><button class="btn btn-default-v2">Quero inovar <br> minha
          campanha</button></a>
    </div>

  </section>

  <section class="bg-section" id="quem-somos">
    <div class="quemsomos-descritivo">
      <div class="quemsomos-titulo">
        <h1>Somos uma <br> plataforma <br>inovadora</h1>
      </div>
      <div class="quemsomos-icones-base">

        <div class="icones-lista">
          <img src="../../../assets/img/institucional/quem-somos/icon_loja.svg" alt="">
          <span>Milhares <br> de produtos</span>
        </div>

        <div>
          <img src="../../../assets/img/institucional/quem-somos/icon_exp.svg" alt="">
          <span>Experiências <br> incríveis</span>
        </div>

        <div>
          <img src="../../../assets/img/institucional/quem-somos/icon_pag.svg" alt="">
          <span>Pagamentos <br> de boletos</span>
        </div>

      </div>
    </div>

    <a (click)="navigateTo('contato')"><button class="btn btn-default-v2">Quero PicPontos <br> Em minha
        campanha</button></a>

    <p>Motivamos sua equipe e participantes de uma forma diferenciada a acumular pontos através de campanhas de
      incentivos.</p>
    <p>Os pontos são trocados por produtos, serviços e experiências incríveis dentro da plataforma ou em sites
      parceiros.</p>

  </section>

  <section class="bg-section full-view" id="produtos">

    <div class="produtos-conteudo">
      <h1>Os melhores <br> parceiros <br> E-Commerce</h1>
      <p>São mais de 100 parceiros, milhares de produtos e serviços, tudo em um só lugar!</p>
      <img src="../../../assets/img/institucional/produtos/premios_mobil.png" alt="">
      <div class="lista-parceiros">
        <img src="../../../assets/img/institucional/produtos/ifood.png" alt="">
        <img src="../../../assets/img/institucional/produtos/zelo.png" alt="">
        <img src="../../../assets/img/institucional/produtos/netflix.png" alt="">
        <img src="../../../assets/img/institucional/produtos/magalu.png" alt="">
        <img src="../../../assets/img/institucional/produtos/tok_stock.png" alt="">
        <img src="../../../assets/img/institucional/produtos/riachuelo.png" alt="">
        <img src="../../../assets/img/institucional/produtos/ponto_frio.png" alt="">
        <img src="../../../assets/img/institucional/produtos/casas_bahia.png" alt="">
        <img src="../../../assets/img/institucional/produtos/submarino.png" alt="">
        <img src="../../../assets/img/institucional/produtos/americanas.png" alt="">
        <img src="../../../assets/img/institucional/produtos/extra.png" alt="">
        <img src="../../../assets/img/institucional/produtos/decathlon.png" alt="">
      </div>
    </div>

  </section>

  <section class="bg-section" id="vantagens">

    <div class="vantagens-titulo">
      <h1>
        Nossas <br>
        Vantagens
      </h1>
      <div class="vantagens-linha"></div>
    </div>

    <div class="vantagens-lista">

      <div class="vantagens-lista-item">
        <img src="../../../assets/img/institucional/vantagens/icon_equipe.svg" alt="">
        <span>Equipe treinada <br> para esclarecer <br> suas dúvidas.</span>
      </div>

      <div class="vantagens-lista-item">
        <img src="../../../assets/img/institucional/vantagens/icon_tarifas.svg" alt="">
        <span>As melhores <br> tarifas e benefícios <br> do mercado.</span>
      </div>

      <div class="vantagens-lista-item">
        <img src="../../../assets/img/institucional/vantagens/icon_sistema.svg" alt="">
        <span>Ambiente seguro <br> e sistema <br> criptografado.</span>
      </div>

      <div class="vantagens-lista-item">
        <img src="../../../assets/img/institucional/vantagens/icon_envio.svg" alt="">
        <span>Entrega garantida <br> em todo terriório <br> nacional.</span>
      </div>

      <div class="vantagens-lista-item">
        <img src="../../../assets/img/institucional/vantagens/icon_chave.svg" alt="">
        <span>Login com chave <br> de acesso e cartão <br> virtual on-line.</span>
      </div>

      <div class="vantagens-lista-item">
        <img src="../../../assets/img/institucional/vantagens/icon_valor.svg" alt="">
        <span>Sua premiação vale <br> mais! 1 PicPontos <br> corresponde a 1 Real.</span>
      </div>

    </div>

    <div class="button">
      <a (click)="navigateTo('contato')"><button class="btn btn-default-v2">Quero Inovar <br> Com PicPontos</button></a>
    </div>

  </section>

  <section class="bg-section" id="contato">

    <div class="contato-titulo">
      <h1>Inove-se</h1>
    </div>

    <div class="contato-conteudo">
      <div class="contato-descritivo">
        <h1>Inspiração,
          Desafios e
          conquistas!</h1>
        <p>A satisfação dos clientes nos inspira, o mercado nos desafia e as batalhas diárias são conquistas
          fundamentais
          para oferecermos os melhores produtos e resultados.</p>
        <p>Sua opinião é muito importante! Escreva suas dúvidas, sugestões, elogios e até mesmo críticas. Peça seu
          orçamento personalizado e inove sua campanha de incentivo com o Pic Pontos.</p>
      </div>

      <div class="contato-form">
        <form ngNativeValidate (submit)="sendBusinessEmail()">

          <div class="form-group col-xs-12">
            <label for="nome">Nome</label>
            <input type="text" id="nome" name="email.nome" [(ngModel)]="email.name" class="form-control input-sm"
              maxlength="100" required [disabled]="processando">
          </div>

          <div class="form-group col-xs-12">
            <label for="empresa">Empresa</label>
            <input type="text" id="empresa" name="email.empresa" [(ngModel)]="email.company"
              class="form-control input-sm" maxlength="100" required [disabled]="processando">
          </div>

          <div class="form-group col-xs-12">
            <label for="email">E-mail</label>
            <input type="email" id="email" name="email.email" [(ngModel)]="email.email" class="form-control input-sm"
              maxlength="100" required [disabled]="processando">
          </div>

          <div class="form-group col-xs-12">
            <label for="telefone">Telefone</label>
            <input type="text" id="telefone" name="email.telefone" [(ngModel)]="email.telephone"
              class="form-control input-sm" maxlength="50" required [disabled]="processando">
          </div>

          <div class="form-group col-xs-12">
            <label for="mensagem">Mensagem</label>
            <textarea type="text" id="mensagem" name="email.mensagem" [(ngModel)]="email.message"
              class="form-control input-sm" maxlength="512" required rows="7" [disabled]="processando"></textarea>
          </div>

          <div class="form-group col-xs-12" style="display: flex; justify-content: center;">
            <re-captcha class="g-recaptcha" [(ngModel)]="email.recaptchaChallenge" name="captcha" [siteKey]="siteKey"
              required></re-captcha>
          </div>

          <div class="contato-button">
            <div *ngIf="processando" class="text-center" style="z-index: 99999; color: #eeefef;">
              <i class="fa fa-spinner fa-pulse fa-4x"></i>
              <p>Carregando...</p>
            </div>
            <button *ngIf="!processando" type="submit" class="btn btn-default-v2">Vamos Inovar Juntos!</button>
          </div>

        </form>
      </div>
    </div>

  </section>


</div>
<app-footer></app-footer>


// WEBPACK FOOTER //
// ./src/app/public/institucional/institucional.component.html